import React from "react";
import TakeATour from "@components/TakeATour";
import DesktopSvg from "@images/arbol/take-a-tour-desktop.svg";
import MobileSvg from "@images/arbol/take-a-tour-mobile.svg";

const LetsTalk = () => (
  <TakeATour DesktopSvg={DesktopSvg} MobileSvg={MobileSvg} />
);

export default LetsTalk;
